<template> 
    <div class="modal-delete-overlay" v-if="showModal">
        <div class="modal-container">
        <h2 class="modal-title text-left fw-600">{{ headTitle }}</h2>
        <p class="modal-text text-left">
            {{ title }}
        </p>
        <div class="modal-actions text-right">
            <a href="javascript:void(0);" class="text-theme mr-3" @click="rejectRequest()">Cancel</a>
            <button type="button" class="confirm-button theme-btn" @click="acceptRequest()">Confirm</button> 
        </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    export default {
        props       : ['title','headTitle'],
        computed    : {
            
        },
        data() {
            return {
                showModal: false
            }
        },
        methods: {
            ...mapActions(["genericAPIPOSTRequest"]),
            async acceptRequest(){
                this.$emit('accept');
            },
            async rejectRequest(){
                this.$emit('reject');
            },
            showModel(_v){
                 this.showModal =_v;
            }
        },
        mounted(){ 

        }
    }
</script>